<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="5">
        <v-card outlined class="pa-6 text-center">

          <v-icon v-if="uspjeh" size="56" color="green" class="mb-4">mdi-check-circle-outline</v-icon>
          <v-icon v-else size="56" color="red" class="mb-4">mdi-alert-circle-outline</v-icon>

          <h2 class="naslov">{{ naslov }}</h2>
          <div class="uz mt-3">{{ objasnjenje }}</div>

          <v-btn color="primary" class="text-none mt-5" @click="dalje">
            {{ uspjeh ? 'Nastavi' : 'Natrag' }}
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Povratak s Teyine prijave.
//
// Kod se NE razmjenjuje ovdje: Teya vraca trgovca na posluzitelj, ondje se
// kod mijenja za token i registrira kasa, a preglednik ovamo stigne tek s
// ishodom u upitu. Tako ni kod ni token nikad ne dodu u preglednik.
export default {
  name: 'teyacallback',

  data () {
    return {
      uspjeh: false,
      poruka: '',
      poslovnica: ''
    }
  },

  computed: {
    naslov () {
      return this.uspjeh ? 'Teya je povezana.' : 'Povezivanje nije uspjelo.'
    },
    objasnjenje () {
      if (!this.uspjeh) {
        return this.poruka || 'Pokušajte ponovno iz postavki Teye.'
      }
      return (this.poslovnica ? `Poslovnica: ${this.poslovnica}. ` : '') +
        'Prijavite se u Roboot i u postavkama Teye odaberite kartični aparat.'
    }
  },

  mounted () {
    const p = this.upit()
    this.uspjeh = p.teya === 'ok'
    this.poruka = p.poruka || ''
    this.poslovnica = p.poslovnica || ''
  },

  methods: {
    /**
     * Kod hash rutiranja upit zna zavrsiti i prije ljestvice, ovisno o tome
     * kako posluzitelj slozi preusmjeravanje - gleda se oboje.
     */
    upit () {
      const iz = (niz) => {
        const q = new URLSearchParams(niz || '')
        return {teya: q.get('teya'), poruka: q.get('poruka'), poslovnica: q.get('poslovnica')}
      }
      const a = iz(window.location.search)
      if (a.teya) { return a }
      const hash = String(window.location.hash || '')
      const at = hash.indexOf('?')
      return at === -1 ? {} : iz(hash.slice(at + 1))
    },

    dalje () {
      // Prijava je prosla kroz cijelo ucitavanje stranice, pa je sjednica
      // Roboota izgubljena - ide se na prijavu.
      this.$router.push({name: 'Login'}).catch(() => {})
    }
  }
}
</script>

<style scoped>
.naslov { font-size: 18px; font-weight: 600; color: #263238; }
.uz { color: #607d8b; font-size: 13px; }
</style>
